export const FETCH_APPOINTMENTS_REQUEST="FETCH_APPOINTMENTS_REQUEST"
export const FETCH_APPOINTMENTS_SUCCESS="FETCH_APPOINTMENTS_SUCCESS"
export const FETCH_APPOINTMENTS_FAILURE="FETCH_APPOINTMENTS_FAILURE"